<nav class="navbar h-full w-full py-md md:py-sm" aria-label="Primary">
  <div class="flex h-full w-full flex-nowrap items-center px-md sm:gap-0 md:gap-lg md:px-xl">
    <bgo-navbar-left class="max-w-20 md:max-w-[500px] md:flex-initial"></bgo-navbar-left>
    <bgo-navbar-center class="!hidden md:!block"></bgo-navbar-center>
    <bgo-navbar-right class="ml-auto mr-0 grow-0"></bgo-navbar-right>
  </div>
</nav>
